export default "<p>discount works!</p>\n"